module.exports = __webpack_public_path__ + "static/img/icon-clock.2f8698f2.png";